var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.23,
    height: 90.23,
    viewBox: "0 0 90.23 90.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-167 -711.77)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 90,
    height: 90,
    rx: 23,
    transform: "translate(167 712)",
    fill: "#fcdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M22.029,0H68.2A22.071,22.071,0,0,1,90.23,22.029V68.2A22.071,22.071,0,0,1,68.2,90.23H22.029A22.071,22.071,0,0,1,0,68.2V22.029A22.071,22.071,0,0,1,22.029,0ZM64.081,47.8a4.131,4.131,0,0,0-6.461,5.05H55.7a5.281,5.281,0,0,1-2.941-.834,4.13,4.13,0,1,0-4.522,6.913A13.577,13.577,0,0,0,55.7,61.107H57.62a4.131,4.131,0,0,0,6.461,5.05l6.258-6.26a4.128,4.128,0,0,0,0-5.841Zm0-23.723a4.131,4.131,0,0,0-6.461,5.049H55.7a13.415,13.415,0,0,0-11.814,6.822l-8.206,14.21a5.192,5.192,0,0,1-4.659,2.691H22.811a4.13,4.13,0,1,0,0,8.261h8.206a13.411,13.411,0,0,0,11.814-6.822l8.2-14.211a5.193,5.193,0,0,1,4.66-2.691H57.62a4.131,4.131,0,0,0,6.461,5.049l6.258-6.258a4.128,4.128,0,0,0,0-5.842l-6.258-6.26Zm-41.27,5.049a4.13,4.13,0,1,0,0,8.261h8.206a5.28,5.28,0,0,1,2.941.833A4.13,4.13,0,0,0,38.479,31.3a13.577,13.577,0,0,0-7.463-2.181Z",
    transform: "translate(167 711.77)",
    fill: "#fef2f2",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeIcon);
export default __webpack_public_path__ + "static/media/change_icon.235cb99ec353cdcf4e138f2a7ff1964d.svg";
export { ForwardRef as ReactComponent };